/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import Button from '~/modules/coreUI/components/basic/Button';
import withCartInfo from '~/modules/core/utils/orderManagementHelpers/withCartInfo';
import commitMutation from '~/modules/core/utils/relayHelpers/commitMutation';
import { LinearLayout } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';

import withRelayEnvironment from '~/modules/core/utils/relayHelpers/withRelayEnvironment';
import withUserInfo from '~/modules/core/utils/accessManagementHelpers/withUserInfo';
import withAlertMsg from '~/modules/core/utils/alertHelpers/withAlertContainer';
import AlertTypes from '~/modules/core/utils/alertHelpers/alertComponent/AlertTypes';
import { getTokenFromLocalStorage } from '~/modules/core/utils/orderManagementHelpers/shoppingCartLocalStorageUtils';
import PackageVariantsContext from '~/modules/ecommerceCoreUI/components/productDetails/packageVariantsContext';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import PopupSelect from '~/modules/coreUI/components/basic/PopupSelect';
import withRootQuery from '~/modules/core/utils/relayHelpers/withRootQuery';
import CurrentUserQuery from '~/modules/accountManagement/containers/accountSettings/queriesAndMutations/CurrentUserQuery';
import { CreateSmartCartMutation, CreateSmartCartMutationRoot } from '~/modules/ecommerceOrder/containers/smartCart/smartCartMutations/CreateSmartCart';
import { AddToCartMutationRoot, AddToCartMutation } from '~/modules/ecommerceOrder/containers/smartCart/smartCartMutations/AddToCart';
import { notifyUnexpectedError } from '~/modules/ecommerceOrder/containers/shoppingCart/utils/ErrorsProcessor';

import CartAlert from './CartAlert';

class CartButton extends Component {
  state = {
    loading: false,
    smartCartIsLoading: false,
  };

  SmartCartOption = () => (
    this.props.queryResult?.current_user_details?.current_user?.smart_carts.length > 0
    && this.props.queryResult?.current_user_details?.current_user?.smart_carts.map(smartCart => ({
      label: smartCart.name,
      value: smartCart.ref_id,
    })));

  onSmartCartMutationError = (errors) => {
    this.setState({
      smartCartIsLoading: false,
    });
    notifyUnexpectedError(this.props, errors);
  };

  onMutationError = (errors) => {
    notifyUnexpectedError(this.props, errors);
    this.setState({
      loading: false,
    });
  };

  notifyErrorAlert = (error) => {
    this.props.notifyAlert({
      component: () => (
        <Label inverted important semiBold>
          <i className="el-icon el-icon-error" />
          &nbsp;
          {error}
        </Label>
      ),
      type: AlertTypes.error,
      opacity: 1,
      toastID: 'Cart_error_toast',
    });
  }

  onMutationSuccess = () => {
    this.setState({
      loading: false,
    });

    this.props.notifyAlert({
      component: () => (
        <CartAlert variant={this.props.variant} />
      ),
      type: AlertTypes.success,
      opacity: 1,
      toastID: `Shopping_Cart_${this.props.variant.ref_id}_success_toast`,
      autoClose: false,
    });
  };

  onSmartCartMutationSuccess = () => {
    this.setState({
      smartCartIsLoading: false,
    });

    this.props.notifyAlert({
      component: () => (
        <CartAlert isAlertSmartCart variant={this.props.variant} />
      ),
      type: AlertTypes.success,
      opacity: 1,
      toastID: `Smart_Cart_${this.props.variant.ref_id}_success_toast`,
    });
  };

  onMutationLoading = () => {
    this.setState({
      loading: true,
    });
  };

  onSmartCartMutationLoading = () => {
    this.setState({
      smartCartIsLoading: true,
    });
  };

  onCreateSmartCartSucceeded = (response) => {
    this.setState({
      smartCartIsLoading: false,
    });
    if (response.add_smart_cart.errors) {
      this.notifyErrorAlert(response.add_smart_cart.errors[0].messages[0]);
    } else {
      this.addProductToSmartCart(response.add_smart_cart.smart_cart.ref_id);
    }
  };


  CreateSmartCart = (smartCartName) => {
    commitMutation(
      this.props.environment,
      CreateSmartCartMutation,
      CreateSmartCartMutationRoot,
      {
        input: {
          name: smartCartName,
        },
      },
      this.onCreateSmartCartSucceeded,
      this.onSmartCartMutationError,
      this.onSmartCartMutationLoading,
    );
  }

  addProductToSmartCart = (smartCartId) => {
    commitMutation(
      this.props.environment,
      AddToCartMutation,
      AddToCartMutationRoot,
      {
        input: {
          vendor_variant_id: parseInt(this.props.variantId.split('-')[1], 10),
          quantity: 1,
          variant_service_ids: this.context.selectedVariants,
          smart_cart_id: smartCartId,
        },
      },
      this.onSmartCartMutationSuccess,
      this.onSmartCartMutationError,
      this.onSmartCartMutationLoading,
    );
  }

  addToSmartCart = (smartCartId) => {
    if (parseInt(smartCartId, 0)) {
      this.addProductToSmartCart(smartCartId);
    } else {
      this.CreateSmartCart(smartCartId);
    }
  }

  addToCart = (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (!this.props.authenticated) {
      commitMutation(
        this.props.environment,
        AddToCartMutation,
        AddToCartMutationRoot,
        {
          input: {
            vendor_variant_id: parseInt(this.props.variantId.split('-')[1], 10),
            quantity: 1,
            variant_service_ids: this.context.selectedVariants,
            guest_tokens: getTokenFromLocalStorage(),
          },
        },
        this.onMutationSuccess,
        this.onMutationError,
        this.onMutationLoading,
      );
    } else {
      commitMutation(
        this.props.environment,
        AddToCartMutation,
        AddToCartMutationRoot,
        {
          input: {
            vendor_variant_id: parseInt(this.props.variantId.split('-')[1], 10),
            quantity: 1,
            variant_service_ids: this.context.selectedVariants,
          },
        },
        this.onMutationSuccess,
        this.onMutationError,
        this.onMutationLoading,
      );
    }
  }

  render() {
    return (
      <LinearLayout row={!this.props.viewAsColumn} fullWidth spaceBetween={1.5}>
        {this.props.authenticated && (
          <PopupSelect
            options={this.SmartCartOption()}
            placeholder={i18next.t('ecommerceOrder:smartCart.smartCartDropdownPlaceholder')}
            onChange={event => this.addToSmartCart(event.value)}
            trigger_inverted
            trigger_bright
            isCreatable
            trigger_label={i18next.t('ecommerceOrder:Cart.addToSmart')}
            create_label={i18next.t('ecommerceOrder:smartCart.createNewSmartCartButton')}
            iconName="el-icon el-icon-smart"
            trigger_buttonContent_fullWidth
            loading={this.state.smartCartIsLoading}
          />
        )}
        <Button
          md
          block
          secondary
          loading={this.state.loading}
          iconName="icon-shop"
          onClicked={this.addToCart}
        >
          {i18next.t('ecommerceOrder:Cart.addToCart')}
        </Button>
      </LinearLayout>
    );
  }
}

CartButton.contextType = PackageVariantsContext;

CartButton.defaultProps = {
  queryResult: null,
};

CartButton.propTypes = {
  environment: PropTypes.shape({}).isRequired,
  notifyAlert: PropTypes.func.isRequired,
  variantId: PropTypes.string.isRequired,
  authenticated: PropTypes.bool.isRequired,
  variant: PropTypes.shape({
    ref_id: PropTypes.string.isRequired,
  }).isRequired,
  queryResult: PropTypes.shape({
    current_user_details: PropTypes.shape({
      current_user: PropTypes.shape({
        smart_carts: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    }),
  }),
  viewAsColumn: PropTypes.bool.isRequired,
};

export default withAlertMsg(withUserInfo(
  withCartInfo(
    withRelayEnvironment(
      withRootQuery(
        CartButton,
        CurrentUserQuery,
        null,
        null,
        { force: true },
      ),
    ),
  ),
));
